import{__assign as t}from"../node_modules/tslib/tslib.es6.js";import{jsx as o}from"react/jsx-runtime";import r from"../components/Footer/index.js";var e=function(e){return o(r,t({},e,{"data-testid":"footer"}))};export{e as default};
//# sourceMappingURL=Footer.js.map
